import React, { useEffect, useState } from 'react';
import Header from './Header';
import Hero from './Hero';
import Skills from './Skills';
import Portfolio from './Portfolio';
import WorkExperiences from './WorkExperience';
import Education from './Education';
import GetIntouch from './GetIntouch';
import Footer from './Footer';
import SectionHeader from './SectionHeader';
import { animateScroll as scroll } from 'react-scroll';
import { Icon } from '@iconify/react';

function MyApp() {
	const [isVisible, setIsVisible] = useState(false);
	useEffect(() => {
		const handler = () => setIsVisible(window.scrollY > 400);
		window.addEventListener('scroll', handler);
		return () => window.removeEventListener('scroll', handler);
	}, []);

	return (
		<div className="bg-primary min-h-screen noise">
			{/* Ambient background orbs */}
			<div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
				<div className="orb w-[800px] h-[800px] bg-accent/5 -top-80 -left-80" />
				<div className="orb w-[600px] h-[600px] bg-accent-2/5 top-1/2 -right-60" />
				<div className="orb w-[400px] h-[400px] bg-violet-500/5 bottom-0 left-1/3" />
			</div>

			<div className="relative z-10">
				<Header />
				<Hero />

				<main>
					<SectionHeader id="skills" title="Technical Skills" subtitle="What I work with" />
					<Skills />

					<SectionHeader id="projects" title="Portfolio Projects" subtitle="Things I've built" />
					<Portfolio />

					<SectionHeader id="experiences" title="Work Experience" subtitle="Where I've worked" />
					<WorkExperiences />

					<SectionHeader id="education" title="Education & Certifications" subtitle="My background" />
					<Education />

					<SectionHeader id="contacts" title="Get in Touch" subtitle="Let's connect" />
					<GetIntouch />
				</main>

				<Footer />
			</div>

			{/* Back to top */}
			<button onClick={() => scroll.scrollToTop()} aria-label="Back to top"
				className={`fixed bottom-8 right-8 w-11 h-11 rounded-xl glass-card border border-slate-700 text-slate-400 flex items-center justify-center hover:border-accent/50 hover:text-white hover:bg-accent/10 transition-all duration-300 z-50 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
				<Icon icon="ep:arrow-up" className="text-lg" />
			</button>
		</div>
	);
}

export default MyApp;
